module.exports = __webpack_public_path__ + "img/corporativo-seg-ocupacional.e2ff1168.png";